<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">{{ title || "Transaction logs" }}</h3>
          <p class="page-head__sub">Monitor and manage all transactions across every IMTO partner.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-hashtag"></i> {{ transactions?.length }} transactions
          </span>
          @if (details?.permission === 'admin') {
            <span class="page-pill page-pill--balance">
              <i class="fa fa-money"></i> Current Balance
              <strong>NGN {{ $safeNavigationMigration(details?.agent?.balance) | number }}</strong>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header card-toolbar">
              <h4 class="card-toolbar__title">
                <i class="fa fa-list-alt"></i> Transaction Report
                <span class="count-pill">{{ transactions?.length }}</span>
              </h4>
              <div class="card-toolbar__actions">
                <app-transaction-filter
                  (closeFilter)="onCloseFilter($event)"
                  (filteredTransactions)="getFilteredTransactions($event)"
                  (onFormReset)="getAllTransactions()"
                  [agents]="agents"
                ></app-transaction-filter>
                <button
                  class="btn btn-outline-success btn-round"
                  type="button"
                  (click)="exportReports()"
                  >
                  <i class="fa fa-download"></i> Download Report
                </button>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive hover">
                @if (transactions?.length > 0) {
                  <table
                    class="table table-de mb-0"
                    >
                    <thead>
                      <tr>
                        <th (click)="sortOrders('transaction_ref')" tabindex="0" (keydown.enter)="sortOrders('transaction_ref')" (keydown.space)="sortOrders('transaction_ref')">
                          Transaction Ref
                          @if (sortType === 'transaction_ref' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'transaction_ref' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('agent')" tabindex="0" (keydown.enter)="sortOrders('agent')" (keydown.space)="sortOrders('agent')">
                          IMTO partner
                          @if (sortType === 'agent' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'agent' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('payout_amount')" tabindex="0" (keydown.enter)="sortOrders('payout_amount')" (keydown.space)="sortOrders('payout_amount')">
                          Amount
                          @if (sortType === 'payout_amount' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'payout_amount' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('amount_sent')">
                          Amount Sent
                          @if (sortType === 'amount_sent' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'amount_sent' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('imto_balance_before')">
                          IMTO Balance Before
                          @if (sortType === 'imto_balance_before' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'imto_balance_before' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        <th (click)="sortOrders('imto_balance_after')">
                          IMTO Balance After
                          @if (sortType === 'imto_balance_after' && !sortReverse) {
                            <i class="icons icon-sort"></i>
                          }
                          @if (sortType === 'imto_balance_after' && sortReverse) {
                            <i class="icons icon-rsort"></i>
                          }
                        </th>
                        @if (
                          details?.permission === 'super_admin' &&
                          (details?.email === 'tbamanga@entrustedltd.com' ||
                          details?.email === 'ayodeji@ionec.com' ||
                          details?.email === 'oolanrewaju@entrustedltd.com' ||
                          details?.email === 'tech@ionec.com')
                          ) {
                          <th
                            (click)="sortOrders('dollar_equivalent')"
                            >
                            USD Equivalent
                            @if (
                              sortType === 'dollar_equivalent' && !sortReverse
                              ) {
                              <i
                                class="icons icon-sort"
                              ></i>
                            }
                            @if (sortType === 'dollar_equivalent' && sortReverse) {
                              <i
                                class="icons icon-rsort"
                              ></i>
                            }
                          </th>
                        }
                        @if (
                          details?.permission === 'super_admin' &&
                          (details?.email === 'tbamanga@entrustedltd.com' ||
                          details?.email === 'ayodeji@ionec.com' ||
                          details?.email === 'oolanrewaju@entrustedltd.com' ||
                          details?.email === 'tech@ionec.com')
                          ) {
                          <th
                            (click)="sortOrders('dollar_rate')"
                            >
                            USD Rate
                            @if (sortType === 'dollar_rate' && !sortReverse) {
                              <i
                                class="icons icon-sort"
                              ></i>
                            }
                            @if (sortType === 'dollar_rate' && sortReverse) {
                              <i
                                class="icons icon-rsort"
                              ></i>
                            }
                          </th>
                        }
                        <th (click)="sortOrders('created_at')" tabindex="0" (keydown.enter)="sortOrders('created_at')" (keydown.space)="sortOrders('created_at')">
                          Date
                          @if (sortType === 'created_at' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'created_at' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('status')" tabindex="0" (keydown.enter)="sortOrders('status')" (keydown.space)="sortOrders('status')">
                          Status
                          @if (sortType === 'status' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'status' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th (click)="sortOrders('message')" tabindex="0" (keydown.enter)="sortOrders('message')" (keydown.space)="sortOrders('message')">
                          Message
                          @if (sortType === 'message' && !sortReverse) {
                            <i
                              class="icons icon-sort"
                            ></i>
                          }
                          @if (sortType === 'message' && sortReverse) {
                            <i
                              class="icons icon-rsort"
                            ></i>
                          }
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        transaction of transactions | paginate : config
                        ; track
                        transaction) {
                        <tr
                          class="pull-up myBox"
                      [routerLink]="[
                        '/transaction',
                        $safeNavigationMigration(transaction?.transaction_ref)
                      ]"
                          >
                          <td>#{{ transaction?.transaction_ref }}</td>
                          <td>{{ transaction?.agent?.name }}</td>
                          <td>NGN {{ $safeNavigationMigration(transaction?.payout_amount) | number }}</td>
                          <td>NGN {{ $safeNavigationMigration(transaction?.amount_sent) | number }}</td>
                          <td>
                            @if (
                              $safeNavigationMigration(transaction?.imto_balance_before) !== null &&
                              $safeNavigationMigration(transaction?.imto_balance_before) !== undefined
                              ) {
                              NGN {{ $safeNavigationMigration(transaction?.imto_balance_before) | number }}
                            }
                            @if (
                              $safeNavigationMigration(transaction?.imto_balance_before) === null ||
                              $safeNavigationMigration(transaction?.imto_balance_before) === undefined
                              ) {
                              <span class="text-muted">&mdash;</span>
                            }
                          </td>
                          <td>
                            @if (
                              $safeNavigationMigration(transaction?.imto_balance_after) !== null &&
                              $safeNavigationMigration(transaction?.imto_balance_after) !== undefined
                              ) {
                              NGN {{ $safeNavigationMigration(transaction?.imto_balance_after) | number }}
                            }
                            @if (
                              $safeNavigationMigration(transaction?.imto_balance_after) === null ||
                              $safeNavigationMigration(transaction?.imto_balance_after) === undefined
                              ) {
                              <span class="text-muted">&mdash;</span>
                            }
                          </td>
                          @if (
                            details?.permission === 'super_admin' &&
                            (details?.email === 'tbamanga@entrustedltd.com' ||
                            details?.email === 'ayodeji@ionec.com' ||
                            details?.email === 'oolanrewaju@entrustedltd.com' ||
                            details?.email === 'tech@ionec.com')
                            ) {
                            <td
                              >
                              {{
                              $safeNavigationMigration(transaction?.dollar_equivalent)
                              | currency : "USD" : "symbol" : "1.2-2"
                              }}
                            </td>
                          }
                          @if (
                            details?.permission === 'super_admin' &&
                            (details?.email === 'tbamanga@entrustedltd.com' ||
                            details?.email === 'ayodeji@ionec.com' ||
                            details?.email === 'oolanrewaju@entrustedltd.com' ||
                            details?.email === 'tech@ionec.com')
                            ) {
                            <td
                              >
                              {{
                              $safeNavigationMigration(transaction?.dollar_rate)
                              | currency : "USD" : "symbol" : "1.2-2"
                              }}
                            </td>
                          }
                          <td>{{ $safeNavigationMigration(transaction?.created_at) | date }}</td>
                          <td>
                            <span
                          class="status-badge status-{{
                            transaction?.status
                          }}"
                              [@statusChange]="$safeNavigationMigration(transaction?.status)"
                              >
                              {{ $safeNavigationMigration(transaction?.status) | uppercase }}
                            </span>
                          </td>
                          <td>
                            {{
                            $safeNavigationMigration(transaction?.message)
                            | slice : 0 : 30 || "Not Specified"
                            }}...
                          </td>
                          <td class="details">
                            <a
                          [routerLink]="[
                            '/transaction',
                            $safeNavigationMigration(transaction?.transaction_ref)
                          ]"
                              class="details"
                              >Details </a
                              ><i class="icons icon-leftt"></i>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  }
                  @if (transactions?.length > 10) {
                    <div
                      style="text-align: center; width: 100%"
                      >
                      <pagination-controls
                        (pageChange)="pageChanged($event)"
                      ></pagination-controls>
                    </div>
                  }
                  @if (transactions?.length === 0) {
                    <div
                      class="empty-state"
                      >
                      {{ emptyTransactionMessage }}
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-bottombar></app-bottombar>
